import { SET_MAP_AND_VIEW, SET_LEGEND_LAYER, SET_SEARCH_RESULTS_LAYER, SET_SELECTED_PARCELS, HIGHLIGHT_PARCELS } from './actionTypes'

export const setMapAndView = (id, map, view) => ({
  type: SET_MAP_AND_VIEW,
  id,
  map,
  view,
})

export const setLegendLayer = (mapId, layer) => ({
  type: SET_LEGEND_LAYER,
  mapId,
  layer
})

export const setSearchResultsLayer = (mapId, layer) => ({
  type: SET_SEARCH_RESULTS_LAYER,
  mapId,
  layer
})

export const setSelectedParcels = (parcels) => ({
  type: SET_SELECTED_PARCELS,
  parcels
})